import React, { useEffect,useState } from "react";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Rightpanel from "./components/Rightpanel";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import Controls from "./components/Controls.jsx";
import PixiCanvas from "./components/pixiComponents/PixiCanvas.jsx";
import FabricCanvas from "./components/FabricComponents/FabricCanvas.jsx";
import { fetchSvgData } from "./Store/reducers/svgSlice.jsx";
import { useLocation } from "react-router-dom";
import MainLoader from "./components/Loaders/MainLoader.jsx"
import Popup from "./components/Popups/Popup.jsx";
import UserFetcher from "./components/userFetcher.jsx";

function App() { 

  const activeTab = useSelector((state) => state.activeTab.activeTab);
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("product_id");

  useEffect(() => {
    dispatch(fetchSvgData(productId || "245258"));
  }, []);

  return (
    <div className="App ">
      <UserFetcher/>
      <div className="flex flex-col   ">
        <Navbar />
        <div className=" flex justify-center items-center ">
          <Controls />
        </div>
        <div className="flex flex-row ">
          <div className="relative  bottom-[40px] ">
            <Sidebar />
          </div>
          <div
            id="sheet"
            className="flex flex-1 content-center justify-center "
          >
            <div className="flex ">
              {["previewMockup"].includes(activeTab) ?
                (
                  <PixiCanvas />
                )
               : (
                <div>
                  <FabricCanvas />
                </div>
              )}
            </div>
          </div>
          <div className="container w-[250px]">
            <div className="absolute right-0  ">
              <Rightpanel />
            </div>
          </div>
        </div>
      </div>
      <Popup/>
    </div>
  );
}

export default App;
